export const Programs = [
"UHS2",
"UHS2 + ACSM",
"UHS4",
"UHS4 + ACSM",
"ES1",
"ES2",
"ES3",
"HL200",
"HL200 + ACSM",
"HL400",
"HL600",
"STX2",
"CHS200",
"PRS100",
"PRS75",
"PRS50"
];